import React, { Component, Fragment } from "react";

// Externals
import classNames from "classnames";
import compose from "recompose/compose";
import PropTypes from "prop-types";

// Material helpers
import { withStyles, withWidth } from "@material-ui/core";

// Material components
import { Drawer } from "@material-ui/core";

// Custom components
import {
  Sidebar,
  Topbar
  // Footer
} from "./components";

// Component styles
import styles from "./styles";
import { dynamicRoutes } from "../../Routes";
import {Slide, ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import './toast-style.css';

//connect redux for language
// import { connect } from "react-redux";
// import { userLanguage, userLogout } from "../../redux/actions";
import ReactNotification from 'react-notifications-component'
import 'react-notifications-component/dist/theme.css'

class Dashboard extends Component {
  constructor(props) {
    super(props);

    const isMobile = ["xs", "sm", "md"].includes(props.width);

    this.state = {
      isOpen: !isMobile,
      title: "میز‌کار"
    };
  }

  componentDidMount() {
    dynamicRoutes(this.props.language).forEach(item => {
      if (item.path === this.props.location.pathname)
        this.setState({ title: item.name });
    });
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.location !== prevProps.location ||
      prevProps.language !== this.props.language
    ) {
      dynamicRoutes(this.props.language).forEach(item => {
        if (item.path === this.props.location.pathname)
          this.setState({ title: item.name });
      });
    }
  }

  handleClose = () => {
    this.setState({ isOpen: false });
  };

  handleToggleOpen = () => {
    this.setState(prevState => ({
      isOpen: !prevState.isOpen
    }));
  };
  handelLang = ({ lang, dir }) => {
    this.props.userLanguage({
      lang: lang,
      dir: dir
    });
  };
  render() {
    const {
      classes,
      width,
      title,
      children,
      language,
      direction,
      userLogout
    } = this.props;
    const { isOpen } = this.state;

    const isMobile = ["xs", "sm", "md"].includes(width);
    const shiftTopbar = isOpen && !isMobile;
    const shiftContent = isOpen && !isMobile;
    return (
      <Fragment>
        <ToastContainer position={direction === "rtl" ? "bottom-right" : "bottom-left"}
                        rtl={direction === "rtl"}
                        closeButton={false}
                        pauseOnVisibilityChange={false}
                        autoClose={3000}
                        transition={Slide}
                        newestOnTop
                        closeOnClick
                        draggable />
        <Topbar
          className={
            classNames(classes.topbar, {
              [direction === "rtl"
                ? classes.topbarShift
                : classes.topbarShiftLtr]: shiftTopbar
            }) + (direction === "rtl" ? " rtl" : " ltr")
          }
          isSidebarOpen={isOpen}
          onToggleSidebar={this.handleToggleOpen}
          // title={title}
          changelang={this.handelLang}
          language={language}
          direction={direction}
          userLogout={userLogout}
          title={title ? title : this.state.title}
        />
        <Drawer
          anchor={direction === "rtl" ? "right" : "left"}
          classes={{
            paper: classes.drawerPaper + (direction === "rtl" ? " rtl" : " ltr")
          }}
          onClose={this.handleClose}
          open={isOpen}
          variant={isMobile ? "temporary" : "persistent"}
        >
          <Sidebar
            className={
              classes.sidebar + (direction === "rtl" ? " rtl" : " ltr")
            }
            language={language}
            direction={direction}
          />
        </Drawer>
        <main
          className={
            classNames(classes.content, {
              [direction === "rtl"
                ? classes.contentShift
                : classes.contentShiftLtr]: shiftContent
            }) + (direction === "rtl" ? " rtl" : " ltr")
          }
        >
          {children}
          {/* <Footer /> */}
        </main>
      </Fragment>
    );
  }
}

Dashboard.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  title: PropTypes.string,
  width: PropTypes.string.isRequired
};

export default compose(
  withStyles(styles),
  withWidth()
)(Dashboard);
